import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  full: {
    marginRight: '5px',
    width: '10px',
    height: '10px',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '100px',
    '@media (max-width: 420px)': {
      width: '8px',
      height: '8px',
    },
  },
  empty: {
    marginRight: '5px',
    width: '10px',
    height: '10px',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '100px',
    '@media (max-width: 420px)': {
      width: '8px',
      height: '8px',
    },
  },
  tubeContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    '& img': {
      marginRight: '5px',
      '@media (max-width: 420px)': {
        marginRight: '4px',
      },
    },
  },
  tube: {
    '@media (max-width: 420px)': {
      width: 'auto',
      height: '30px',
    },
  },
}))

export const Rating = ({ value }: { value: string }): JSX.Element => {
  const classes = useStyles({})
  const rating = parseInt(value, 10)
  if (!rating) {
    return <></>
  }

  return (
    <div className={classes.container}>
      {[...Array(rating)].map((e, i) => (
        <span className={classes.full} key={i} />
      ))}
      {rating < 5 &&
        [...Array(5 - rating)].map((e, i) => <span className={classes.empty} key={i} />)}
    </div>
  )
}

export const MainScore = ({ value, color }: { value: string; color: string }): JSX.Element => {
  const classes = useStyles({})
  const rating = parseFloat(value)

  if (!rating) {
    return <></>
  }
  const hasHalf = rating % 1 > 0
  const totalEmpty = 5 - Math.floor(rating) - Math.ceil(rating % 1)

  return (
    <div className={classes.tubeContainer}>
      {[...Array(Math.floor(rating))].map((e, i) => (
        <img
          width={10}
          height={36}
          src={`/svg/bar-full-${color}.svg`}
          key={i}
          alt="rating full icon"
          className={classes.tube}
        />
      ))}
      {hasHalf && (
        <img width={10} height={36} src={`/svg/bar-half-${color}.svg`} className={classes.tube} />
      )}
      {totalEmpty > 0 &&
        [...Array(totalEmpty)].map((e, i) => (
          <img
            width={10}
            height={36}
            src={`/svg/bar-empty-${color}.svg`}
            key={i}
            alt="rating empty icon"
            className={classes.tube}
          />
        ))}
    </div>
  )
}
